import {
  Component,
  ElementRef,
  inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { CerrixIconComponent } from '../cerrix-icon/cerrix-icon.component';

@Component({
    selector: 'cerrix-drop-menu',
    imports: [CerrixIconComponent],
    templateUrl: './cerrix-drop-menu.component.html',
    styleUrl: './cerrix-drop-menu.component.scss'
})
export class CerrixDropMenuComponent implements OnInit {
  @Input() public icon: string = 'hamburger-menu';
  @Input() public iconColor: string = '#000';
  @Input() public iconSize: number = 24;
  @Input() public dropPosition: 'top' | 'bottom' | 'left' | 'right' | 'auto' =
    'auto';
  @Input() public dropCorner: 'start' | 'end' | 'auto' = 'auto';
  @Input() public dropMenuOnTop: boolean = false;
  @Input() public listReverse: boolean = false;
  @Input() public listItemReverse: boolean = false;
  @Input() public openOnHover: boolean = false;
   @Input() public dataUiid: string = "undefined"

  @ViewChild('menuButton', { static: true })
  menuButton?: ElementRef<HTMLElement>;
  @ViewChild('menuList', { static: true }) menuList?: ElementRef<HTMLElement>;

  protected isOpen: boolean = false;

  private readonly componentRef = inject(ElementRef<HTMLElement>);

  private clickEvent: Subscription = new Subscription();
  private scrollEvent: Subscription = new Subscription();
  private resizeEvent: Subscription = new Subscription();

  private menuItems: Array<ChildNode> = [];

  ngOnInit(): void {
    this.menuItems = Array.prototype.slice.call(
      this.menuList?.nativeElement.childNodes
    );
  }

  public openMenu(): void {
    this.isOpen = true;

    this.calculateDropMenuPosition();

    this.clickEvent = fromEvent(document, 'mouseup').subscribe(e => {
      if (
        this.menuItems.some(mi => mi.contains(e.target as HTMLElement)) ||
        !this.componentRef?.nativeElement.contains(e.target as HTMLElement)
      ) {
        this.closeMenu();
      }
    });

    if (this.dropMenuOnTop) {
      this.calculateDropMenuFixedPosition();
    }

    this.scrollEvent = fromEvent(window, 'wheel').subscribe(e => {
      this.closeMenu();
    });
    this.resizeEvent = fromEvent(window, 'resize').subscribe(e => {
      this.closeMenu();
    });
  }

  public closeMenu(): void {
    this.isOpen = false;
    this.clickEvent.unsubscribe();
    this.scrollEvent.unsubscribe();
    this.resizeEvent.unsubscribe();
  }

  public toggleMenu(): void {
    !this.isOpen ? this.openMenu() : this.closeMenu();
  }

  private calculateDropMenuPosition(): void {
    const menuButtonBounding =
      this.menuButton?.nativeElement.getBoundingClientRect();

    if (menuButtonBounding && this.menuList) {
      if (this.dropPosition === 'auto') {
        if (
          window.innerHeight -
            menuButtonBounding.top -
            menuButtonBounding.height <
          this.menuList.nativeElement.offsetHeight
        ) {
          this.dropPosition = 'top';
        } else {
          this.dropPosition = 'bottom';
        }
      }

      if (this.dropCorner === 'auto') {
        if (
          window.innerWidth - menuButtonBounding.left <
          this.menuList.nativeElement.offsetWidth
        ) {
          this.dropCorner = 'end';
        } else {
          this.dropCorner = 'start';
        }
      }
    }
  }

  private calculateDropMenuFixedPosition(): void {
    const menuButtonBounding =
      this.menuButton?.nativeElement.getBoundingClientRect();
    if (menuButtonBounding) {
      switch (this.dropPosition) {
        case 'top':
          this.menuList?.nativeElement.style.setProperty(
            'top',
            `${menuButtonBounding.top - this.menuList.nativeElement.offsetHeight}px`
          );
          this.menuList?.nativeElement.style.setProperty(
            'left',
            this.dropCorner === 'end'
              ? `${menuButtonBounding.left + menuButtonBounding.width - this.menuList.nativeElement.offsetWidth}px`
              : `${menuButtonBounding.left}px`
          );
          break;
        case 'bottom':
          this.menuList?.nativeElement.style.setProperty(
            'top',
            `${menuButtonBounding.top + menuButtonBounding.height}px`
          );
          this.menuList?.nativeElement.style.setProperty(
            'left',
            this.dropCorner === 'end'
              ? `${menuButtonBounding.left + menuButtonBounding.width - this.menuList.nativeElement.offsetWidth}px`
              : `${menuButtonBounding.left}px`
          );
          break;
        case 'left':
          this.menuList?.nativeElement.style.setProperty(
            'top',
            this.dropCorner === 'end'
              ? `${menuButtonBounding.top + menuButtonBounding.height - this.menuList.nativeElement.offsetHeight}px`
              : `${menuButtonBounding.top}px`
          );
          this.menuList?.nativeElement.style.setProperty(
            'left',
            `${menuButtonBounding.left - this.menuList.nativeElement.offsetWidth}px`
          );
          break;
        case 'right':
          this.menuList?.nativeElement.style.setProperty(
            'top',
            this.dropCorner === 'end'
              ? `${menuButtonBounding.top + menuButtonBounding.height - this.menuList.nativeElement.offsetHeight}px`
              : `${menuButtonBounding.top}px`
          );
          this.menuList?.nativeElement.style.setProperty(
            'left',
            `${menuButtonBounding.left + menuButtonBounding.width}px`
          );
          break;
      }
    }
  }
}
